import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Panel, SandboxNotice, fmtMoney } from "@/components/Peep";

const COLS = [["gross", "Gross"], ["processing_fees", "Processing fees"], ["refunds", "Refunds"], ["chargebacks", "Chargebacks"], ["platform_fees", "Platform fees"], ["earnings", "Earnings / net"]];

export function RevenueTable({ rows, testid, showPayout = true }) {
  return (
    <div className="overflow-x-auto">
      <table data-testid={testid} className="w-full min-w-[640px] text-left text-sm">
        <thead className="text-[0.65rem] uppercase tracking-wider text-[#a7a0af]">
          <tr><th className="py-2 pr-3">Account</th>{COLS.map(([, l]) => <th key={l} className="py-2 pr-3">{l}</th>)}{showPayout && <th className="py-2">Payout</th>}</tr>
        </thead>
        <tbody>
          {rows.map(({ label, r, id }) => (
            <tr key={label} data-testid={`rev-row-${id}`} className="border-t border-white/10">
              <td className="py-2 pr-3 font-semibold">{label}</td>
              {COLS.map(([k]) => <td key={k} data-testid={`rev-${id}-${k}`} className="py-2 pr-3">{fmtMoney(r[k])}</td>)}
              {showPayout && <td className="py-2 text-xs text-[#a7a0af]">See Finance</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function AdminRevenue() {
  const [d, setD] = useState(null);
  const load = useCallback(() => {
    api.get("/admin/revenue").then((r) => setD(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  const allocate = async () => {
    try {
      const { data } = await api.post("/admin/revenue/allocate-unallocated");
      toast.success(`Allocated ${data.reallocated_entries} ledger entries`);
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };
  if (!d) return <p className="text-sm text-[#a7a0af]">Loading…</p>;
  const rows = [
    ...d.by_creator.map((x) => ({ id: x.creator.handle, label: x.creator.display_name, r: x.revenue })),
    { id: "unallocated", label: "Unallocated All Access", r: d.unallocated_bundle },
    { id: "platform", label: "Platform total", r: d.platform },
  ];
  return (
    <div data-testid="admin-revenue" className="flex flex-col gap-6">
      <div>
        <h1 className="text-3xl font-extrabold">Revenue & payouts</h1>
        <p className="mt-1 text-sm text-[#a7a0af]">Separate accounting per creator from the PEEPING PAY ledger.</p>
      </div>
      <SandboxNotice />
      <Panel title="Ledger summary" action={<button onClick={allocate} data-testid="allocate-unallocated-btn" className="rounded-xl border border-[#6a00ff]/40 px-3 py-1.5 text-xs text-[#c9a6ff]">Allocate unallocated bundle revenue</button>}>
        <RevenueTable rows={rows} testid="admin-revenue-table" />
        <p className="mt-3 text-xs text-[#6f6878]">Automated creator payouts are disabled until a processor with marketplace / connected-account payouts is approved.</p>
      </Panel>
    </div>
  );
}
